import React, { useEffect } from 'react'
import { Button, Card, Space, Toast } from 'antd-mobile-v5'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useAutoRenew, useGetAutoRenewPrice } from '../../services/hooks'
import styles from './RenewalLanding.module.scss'

const RenewalLanding = () => {
  const { push } = useHistory()
  const { data: price } = useGetAutoRenewPrice()
  const { data: autoRenew } = useAutoRenew()
  // 签约开关关闭时卡片仍展示，但点击不进入（只提示）
  const canSignup = !autoRenew || autoRenew.canSignup !== false

  useEffect(() => {
    document.body.style.setProperty('background-color', '#ffffff', 'important')

    return () => {
      document.body.style.setProperty('background-color', '#f5f5f9', 'important')
    }
  }, [])

  const handleAutoRenewClick = () => {
    if (!canSignup) {
      Toast.show('自动更新暂未开放')
      return
    }
    push('/auto_renew')
  }

  const handleManageAutoClick = () => {
    // 已签约的「管理自动更新」不受签约开关影响（要能进去解绑）
    push('/auto_renew')
  }

  const handleOneTimeRenewClick = () => {
    push('/renew/member')
  }

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>
        <FormattedMessage id="renewal-landing-title" />
      </h4>

      <Space direction="vertical" className={styles.options}>
        {price && !price.renewed && (
          <>
            <Card className={styles.optionCard}>
              <div className={styles.cardContent}>
                <h2 className={styles.optionTitle}>
                  <FormattedMessage id="renewal-landing-auto-title" />
                </h2>
                <p className={styles.optionDescription}>
                  <FormattedMessage id="renewal-landing-auto-desc" />
                </p>
                {price && (
                  <>
                    <p className={styles.optionDescription}>更新价格低至</p>
                    <div className={styles['price-box']}>
                      <span className={styles.price}>{price.autoRenewalPrice}</span>
                      <span className={styles.currency}>{price.currencyType}</span>
                    </div>
                  </>
                )}
                <div className={styles.optionButton} onClick={handleAutoRenewClick}>
                  {canSignup ? <FormattedMessage id="renewal-landing-auto-btn" /> : '暂未开放'}
                </div>
              </div>
            </Card>

            <Card className={styles.optionCard}>
              <div className={styles.cardContent}>
                <h2 className={styles.optionTitle}>
                  <FormattedMessage id="renewal-landing-onetime-title" />
                </h2>
                <p className={styles.optionDescription}>
                  <FormattedMessage id="renewal-landing-onetime-desc" />
                </p>
                {price && (
                  <>
                    <p className={styles.optionDescription}>更新价格低至</p>
                    <div className={styles['price-box']}>
                      <span className={styles.price}>{price.oneTimePrice}</span>
                      <span className={styles.currency}>{price.currencyType}</span>
                    </div>
                  </>
                )}
                <Button color="primary" className={styles.optionButton} onClick={handleOneTimeRenewClick}>
                  <FormattedMessage id="renewal-landing-onetime-btn" />
                </Button>
              </div>
            </Card>
          </>
        )}

        {price &&
          price.renewed &&
          price.renewalHistory &&
          price.renewalHistory.Items &&
          price.renewalHistory.Items.length > 0 && (
            <Card className={styles.optionCard}>
              <div className={styles.cardContent}>
                <h2 className={styles.optionTitle}>当前状态</h2>
                <p className={styles.optionDescription}>您的 PADI 会员资格已续订 2026</p>
                {price.renewalHistory.MembershipExpires && (
                  <p className={styles.optionDescription}>会员到期时间: 12月31日</p>
                )}
                <div className={styles.historyList}>
                  {price.renewalHistory.Items.map((item, index) => (
                    <div key={index} className={styles.historyItem}>
                      <p className={styles.historyYear}>更新记录</p>
                      <p className={styles.historyYear}>年份: {item.Year}</p>
                      <p className={styles.historyType}>
                        会员类别: {item.MembershipType === 'onetime' ? '一次性续费' : '自动续费'}
                      </p>
                      {/*<p className={styles.CreditCardTypeId}>支付方式: {item.CreditCardTypeId}</p>*/}
                    </div>
                  ))}
                </div>
                {price.renewalHistory.Items.some((item) => item.MembershipType === 'auto') && (
                  <Button color="primary" className={styles.optionButton} onClick={handleManageAutoClick}>
                    <FormattedMessage id="renewal-landing-manage-auto" />
                  </Button>
                )}
              </div>
            </Card>
          )}
      </Space>
    </div>
  )
}

export default RenewalLanding
